<template>
  <a-form id="notification-form" class="flex-grow-1 d-flex flex-column" :form="notificationForm" @submit="onSubmit">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">{{ notification.id ? 'Edit' : 'Add New' }} Notification</span>
    </div>
    <div class="a-body flex-grow-1 p-20-px slide-up-enter-active">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="Webpage URL">
            <a-select
              v-decorator="[
                'url_id',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please select Webpage URL!'
                    }
                  ]
                }
              ]"
              showSearch
              :filterOption="filterOption"
              size="large"
            >
              <a-select-option v-for="url in urls" :key="url.id" :value="url.id">
                {{ url.url }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="Contact Group">
            <a-select
              v-decorator="[
                'contact_group_id',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please select Contact Group!'
                    }
                  ]
                }
              ]"
              showSearch
              :filterOption="filterOption"
              size="large"
            >
              <a-select-option v-for="group in contactGroups" :key="group.id" :value="group.id">
                {{ group.description }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="Notification Type">
            <a-select
              v-decorator="[
                'notification_type',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please select Notification Type!'
                    }
                  ]
                }
              ]"
              size="large"
            >
              <a-select-option v-for="type in notificationTypes" :key="type.id" :value="type.id">
                {{ type.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </div>
    <div class="a-footer">
      <a-button key="back" size="large" class="mr-3 slide-down-enter-active" @click="onCancel()">
        Cancel
      </a-button>
      <a-button key="submit" size="large" type="primary" html-type="submit" class="slide-down-enter-active">
        Save
      </a-button>
    </div>
  </a-form>
</template>

<script>
  import { NOTIFICATION_TYPES, NOTIFICATION_TYPE_SMS } from '@constants/notifications';

  import NotificationService from '../services/notification.service';
  import ContactGroupService from '@modules/ContactGroup/services/contact-group.service';

  export default {
    name: 'NotificationForm',
    props: {
      notification: {
        id: Number,
        contact_group_id: Number,
        url_id: Number,
        notification_type: String
      }
    },
    data() {
      return {
        contactGroups: [],
        urls: [],
        notificationTypes: []
      };
    },
    computed: {
      featureAccess() {
        return this.$store.state.user.data.feature_access;
      },
      isShowSMSNotification() {
        return Boolean(this.featureAccess['sms']);
      }
    },
    watch: {
      notification: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setNotificationForm();
        }
      }
    },
    beforeCreate() {
      this.notificationForm = this.$form.createForm(this, {
        name: 'notification-form'
      });
    },
    mounted() {
      Promise.all([this.getContactGroupList(), this.getUrlList(), this.getNotificationTypes()]).then(() => {
        this.setNotificationForm();
      });
    },
    methods: {
      onSubmit(e) {
        e.preventDefault();
        this.notificationForm.validateFields((err, values) => {
          if (!err) {
            this.$emit('submit', values);
          }
        });
      },
      onCancel() {
        this.$router.push('/notification/list');
      },
      getNotificationTypes() {
        const $notificationType = new Promise((resolve) => {
          if (!this.isShowSMSNotification) {
            this.notificationTypes = NOTIFICATION_TYPES.filter((item) => {
              return item.id !== NOTIFICATION_TYPE_SMS;
            });
          } else {
            this.notificationTypes = NOTIFICATION_TYPES;
          }
          resolve(this.notificationTypes);
        });
        return $notificationType;
      },
      getContactGroupList() {
        return ContactGroupService.getList().then((data) => {
          this.contactGroups = data;
          return this.contactGroups;
        });
      },
      getUrlList() {
        return NotificationService.getUrlList().then((data) => {
          this.urls = data;
          return this.urls;
        });
      },
      setNotificationForm() {
        this.notificationForm.setFieldsValue({
          url_id: this.notification.url_id || this.urls[0].id,
          contact_group_id: this.notification.contact_group_id || this.contactGroups[0].id,
          notification_type: this.notification.notification_type || this.notificationTypes[0].id
        });
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }
    }
  };
</script>

<style lang="scss" scoped></style>
